<template>
	<div class="col-12 pl-0 pr-0">
		<div v-if="dataSerial.length > 0">
			<div class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan pilih tipe serial yang akan dijual</div>
			</div>
			<div class="col-12 p-4 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-12 px-0 d-flex flex-wrap justify-content-center" v-if="dataSerial.length > 0">
					<div class="col-12 col-sm-6 px-0 pb-3 d-flex">
						<div class="col-11 px-0">
							<v-select :value="serialType" :options="typesOptNew" class="font-size-10 rounded-cus focus-me" @input="serialTypeChange($event)"
								label="label" :reduce="type => type.code" :selectable="option => ! option.disabled">
							</v-select>
						</div>
					</div>
				</div>
				<div class="col-12 font-size-9 text-danger text-center">{{ serialTypeErrorMessage }}</div>
			</div>
		</div>
		<div class="col-12 p-4 mt-3 bg-white cus-box-shadow rou	nded-cus d-flex flex-wrap" v-if="serialType == 2">
			<div class="col-12 px-0 d-flex flex-wrap justify-content-center">
				<div class="col-12 px-0 pb-3 d-flex justify-content-center">
					<div class="col-6">BV Tersedia</div>
					<div class="col-6 d-flex align-items-startl justify-content-end">
						<span class="bg-template text-white text-center w-50 mr-1 rounded">
							{{ serialDigitalAvailable }}
						</span>
						BV
					</div>
				</div>
				<div class="col-12 px-0 pb-3 d-flex justify-content-center">
					<div class="col-6">BV Yang Akan Dijual</div>
					<div class="col-6 d-flex align-items-start justify-content-end">
						<span class="bg-template text-white text-center w-50 mr-1 rounded">
							{{ serialDigitalToSell }} 
						</span>
						BV
					</div>
				</div>
			</div>
		</div>

		<div v-if="serialType == 1">
			<div class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan pilih {{ serialText }} yang akan dijual</div>
			</div>
			<div class="col-12 p-4 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-12 px-0 d-flex flex-wrap justify-content-center" v-if="dataSerial.length > 0">
					<div class="col-12 px-0 pb-3 d-flex flex-wrap justify-content-center">
						<div class="col-12 text-center">
							<div class="pb-2 font-size-10">Silahkan Scan Serial Produk</div>
							<p class="danger" v-if="noFrontCamera && camera == 'front'">
								Perangkat yang Anda gunakan tidak memiliki kamera depan
							</p>
							<p class="danger" v-if="noRearCamera && camera == 'rear'">
								Perangkat yang Anda gunakan tidak memiliki kamera belakang
							</p>
						</div>
						<div class="col-12 col-sm-6 p-4 container-scanner">
							<img class="scan-icon-top-left" src="/assets/icon/scan-icon.png">
							<QrcodeStream @decode="onDecode" :class="camera == 'front' ? 'front-camera' : ''" @init="onInit" :camera="camera">
								<div class="text-right">
									<button @click="switchCamera">
										<img src="/assets/icon/camera-switch.svg" alt="switch camera">
									</button>
								</div>
							</QrcodeStream>
							<img class="scan-icon-bot-right" src="/assets/icon/scan-icon.png">
						</div>
					</div>
					<div class="col-12 col-sm-6 px-0 pb-3 d-flex">
						<!-- <input type="text" @keyup.enter="checkMLMSerial" v-model="serialInput" class="form-control form-control-sm font-size-10 rounded-cus focus-me"> -->
						<div class="col-11 px-0">
							<v-select v-model="serialInput" :options="serialOwnedList" appendToBody class="font-size-10 rounded-cus focus-me"
								label="stock_serial_value" taggable :create-option="el => ({ stock_serial_value: el })"
								:reduce="el => `${el.stock_serial_value}`" @input="checkMLMSerial">
								<template v-slot:no-options>
									Saat ini tidak ada serial yang tersedia
								</template>
							</v-select>
						</div>
						<div class="col-1 px-0">
							<button class="btn pr-0 btn-link-blue btn-hover no-box-focus" @click="checkMLMSerial">
								<div class="font-size-9 font-size-sm-9">Cari</div>
							</button>
						</div>
					</div>
				</div>
				<div class="col-12 px-0 d-flex flex-wrap justify-content-center" v-else>
					<div class="col-12 text-center">
						<div class="pb-2 font-size-10">Untuk transaksi ini tidak membutuhkan scan serial. Silahkan melanjutkan ke langkah
							selanjutnya.</div>
					</div>
				</div>
				<div class="col-lg-6 pl-0 pl-lg-2 pr-0" v-for="(product, i) in dataSerial" :key="i">
					<!-- Pencarian Selected -->
					<div class="col-12 mt-2 font-size-10 label-detail-product-serial">
						<span>{{ product.product_code }}</span>
					</div>
					<div class="col-12 mt-2 font-size-10 label-detail-product-serial">
						<span>{{ serialOptionName[product.type] }} Terpilih ({{ product.serial ? product.serial.length : 0 }} dari
							{{ product.max_qty }})</span>
					</div>
					<div class="col-12 mt-2 pt-2 pb-2 bg-white border-2 rounded-cus">
						<div class="col-12 p-0 d-flex">
							<div class="col-6 pl-0 pr-0 mt-auto mb-auto">
								<label class="container-serial font-size-9 mb-0">Pilih Semua
									<input v-model="product.removeAll" type="checkbox"
										@input="checkSerialSelected(product.product_code, product.type, $event)">
									<span class="checkmark checkmark-red"></span>
								</label>
							</div>
							<div class="col-6 pl-0 pr-0 text-right">
								<button @click="hapusSelected(product.product_code, product.type, product.serialSelected)"
									class="btn pr-0 btn-link-red btn-hover no-box-focus">
									<div class="font-size-9 font-size-sm-9">Batalkan Terpilih</div>
								</button>
							</div>
						</div>
						<!-- Serial  -->
						<div class="col-12 pl-0 pr-0">
							<div v-if="!product.serial" class="col-12 pl-0 pr-0 mt-2 mb-2 text-center serial-body">
								<img class="pt-5" src="/assets/transaction/empty-serial-icon.svg">
								<div class="font-size-10 pt-2">Belum ada Serial terpilih</div>
							</div>
							<div v-else class="col-12 pl-0 pr-0 mt-2 mb-2 serial-body" :id="'serial-body-selected' + i">
								<div :id="'container-selected' + i">
									<label class="container-serial d-flex" v-for="(value, index) in product.serial" :key="index">
										<span class="serial-item font-size-10">{{ value }}</span>
										<input v-model="product.serialSelected" type="checkbox" :value="value"
											@change="checkSerial(product.product_code, product.type)">
										<span class="checkmark checkmark-red mt-c04"></span>
										<button @click="remove(product.product_code, product.type, value)" type="button"
											class="btn btn-del-serial text-white no-box-focus"><i
												class="fas fa-minus-circle font-size-10"></i></button>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { QrcodeStream } from 'vue-qrcode-reader'
import $ from 'jquery';
import moment from 'moment';

export default {
	components: {
		QrcodeStream
	},
	data() {
		return {
			kosong: false,
			empty: true,
			params: [],
			serial: {
				value: '2',
				comparison: '=',
				type: 'string',
				field: 'stock_serial_type'
			},
			serialInput: '',
			camera: 'front',
			typesOpt: [
				{
					label: 'Digital',
					code: 2,
				}
			],
			noRearCamera: false,
			noFrontCamera: false,
			bvAvailable: 0,
			bvToSell: 0,
		}
	},
	computed: {
		...mapState('cart', ['cart', 'mitra', 'register', 'registerItem', 'dataCheckSerial', 'dataProduk', 'dataSerial', 'serialOwnedList', 'serialOptionName', 'serialType', 'serialDigitalAvailable', 'serialDigitalToSell']),

		serialText() {
			var serial_text = ''
			this.dataSerial.forEach((element, index) => {
				if (index == 0) {
					serial_text += `${element.max_qty} ${element.product_code} `
				} else if (index == (this.dataSerial.length - 1)) {
					serial_text += `dan ${element.max_qty} ${element.product_code}`
				} else {
					serial_text += `, ${element.max_qty} ${element.product_code} `
				}
			})
			return serial_text
		},
		typesOptNew() {
			var disabled_option = false

			if (!this.mitra) {
				disabled_option = true
			} else {
				this.cart.forEach((el) => {
					if (el.product_code == 'SKM') {
						disabled_option = true
					}
				})
			}

			var option = [
				{
					label: 'Digital',
					code: 2,
					disabled: disabled_option,
				}
			]

			return option
		},
		serialTypeErrorMessage() {
			var errorMsg = ''

			if (!this.mitra) {
				errorMsg = 'Transaksi Mitra Baru hanya bisa dilakukan menggunakan serial fisik.'
			} else {
				this.cart.forEach((el) => {
					if (el.product_code == 'SKM') {
						errorMsg = 'Produk Starter Kit Mitra Usaha hanya bisa ditransaksikan secara fisik.'
					}
				})
			}

			return errorMsg
		}
	},
	methods: {
		...mapActions('cart', ['checkSerialMLM', 'getSerialOwnedList', 'getOptionSerialName', 'getSerialDigitalAvailable']),
		...mapMutations('cart', ['setDataSerial', 'setSerialType', 'pilihSerial', 'removeSelected', 'checkSelected', 'removeAll', 'setAlertKeranjang', 'loadMoreSerial', 'resetDataSerial', 'setDataSerial', 'cariSerial', 'cariSerialSelected', 'setSerialDigitalToSell']),
		...mapActions('transactionList', ['scanLinkSerial']),

		switchCamera() {
			switch (this.camera) {
				case 'front':
					this.camera = 'rear'
					break
				case 'rear':
					this.camera = 'front'
					break
			}
		},
		async onInit(promise) {
			try {
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
				}
			}
		},
		onDecode(val) {
			if (val) {
				this.scanLinkSerial(val).then(({ data }) => {
					this.serialInput = data.serial
					this.checkMLMSerial()
				})
			}
		},
		checkSerial(i, type) {
			this.checkSelected({
				index: i,
				type: type
			})
		},
		checkSerialSelected(i, type, $event) {
			const checked = $event.target.checked
			this.removeAll({
				index: i,
				type: type,
				value: checked
			})
		},
		remove(i, type, value) {
			this.removeSelected({
				indexType: i,
				type: type,
				serial: [value]
			})
		},
		hapusSelected(i, type, val) {
			var data = [...val];
			this.removeSelected({
				indexType: i,
				type: type,
				serial: data
			})
			this.focusOnInput()
		},
		checkMLMSerial() {
			if (this.serialInput) {
				this.checkSerialMLM({
					serial: this.serialInput
				}).then(() => {
					this.serialInput = ''
					this.focusOnInput()
				})
			}
		},
		serialTypeChange(val) {
			this.setSerialType(val)
			this.getTypeSerialDigital()
		},
		focusOnInput() {
			$('.focus-me').focus()
		},
		getTypeSerialDigital() {
			this.getSerialDigitalAvailable()

			if (this.cart.length > 0) {
				var bv = 0

				this.cart.forEach((el) => {
					bv += parseInt(el.product_bv * el.quantity)
				})

				this.setSerialDigitalToSell(bv)
			}
		},
		checkSerialType() {
			if (!this.mitra) {
				this.setSerialType(1)
			} else {
				this.cart.forEach((el) => {
					if (el.product_code == 'SKM') {
						this.setSerialType(1)
					}
				})
			}
		}
	},
	created() {
		this.getOptionSerialName()
		let serial = [... this.dataSerial]
		let serialTemp = []
		this.cart.forEach((element) => {
			if (element.product_is_serial) {
				let serialNeeded = JSON.parse(element.product_is_serial)
				serialNeeded.forEach(isSerialEl => {
					let indexSerial = serial.findIndex(el => element.product_code == el.product_code && el.type == isSerialEl.type_id)
					let data = {
						type: isSerialEl.type_id,
						serial: [],
						removeAll: false,
						product_code: element.product_code,
						serialSelected: [],
						max_qty: parseInt(element.quantity) * isSerialEl.quantity
					}
					if (indexSerial != -1) {
						data.serial = serial[indexSerial].serial
					}
					serialTemp.push(data)
				})
			}
		});
		if (this.register || !this.mitra) {
			if (this.registerItem.serial) {
				let indexCart = this.cart.findIndex((el) => {
					return this.registerItem.code == el.product_code
				})

				let serialNeeded = JSON.parse(this.registerItem.serial)
				let serialRegisterQty = 0;
				if (this.cart[indexCart]) {
					serialRegisterQty = parseInt(this.cart[indexCart].quantity)
				}

				serialNeeded.forEach(isSerialEl => {
					let indexSerial = serial.findIndex(
						el => this.registerItem.code == el.product_code &&
							el.type == isSerialEl.type_id
					)
					let data = {
						type: isSerialEl.type_id,
						serial: [],
						removeAll: false,
						product_code: this.registerItem.code,
						serialSelected: [],
						max_qty: serialRegisterQty + parseInt(this.registerItem.quantity) * isSerialEl.quantity
					}
					if (indexSerial != -1) {
						data.serial = serial[indexSerial].serial
					} else {
						serialTemp.push(data)
					}
				})
			}
		}
		this.setDataSerial(serialTemp)
		let serial_type_list = serialTemp.map(el => {
			return el.type
		})
		let params = [{
			value: serial_type_list.join('::'),
			comparison: 'yes',
			type: 'list',
			field: 'stock_serial_type',
		}, {
			value: '0',
			comparison: '=',
			type: 'string',
			field: 'stock_serial_status',
		}, {
			value: 'pos',
			comparison: '=',
			type: 'string',
			field: 'stock_serial_used_for',
		},
		{
			value: moment(new Date()).format('YYYY-MM-DD'),
			comparison: '>',
			type: 'date',
			field: 'stock_serial_expired_datetime',
		}];
		this.getSerialOwnedList(this.queryString({ params: params }))
		this.getTypeSerialDigital()
		this.checkSerialType()
	},
	mounted() {
		this.focusOnInput()
	}
};
</script>
